// react and external libraries
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';

// own components
import Button from '../../views/Button';

// css styles
import styles from './MessageModal.module.css';

import { removeMessage } from './actions';

class MessageModal extends PureComponent {

    componentDidMount() {
        document.addEventListener('keydown', this.handleEscapePress);
        document.addEventListener('mousedown', this.handleClickOutsideModal);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleEscapePress);
        document.removeEventListener('mousedown', this.handleClickOutsideModal);
    }

    handleClickOutsideModal = (event) => {
        if (!!this.modalRef && !this.modalRef.contains(event.target)) {
            const { messages } = this.props;

            const message = !!messages && messages.length > 0 ? messages[0] : null;
            if (!!message) {
                this.handleCloseClick(message.id)();
            }
        }
    }

    handleEscapePress = (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') {
            const { messages } = this.props;

            const message = !!messages && messages.length > 0 ? messages[0] : null;
            if (!!message) {
                this.handleCloseClick(message.id)();
            }
        }
    }

    setModalRef = (node) => {
        this.modalRef = node;
    }

    handleCloseClick = (messageId) => () => {
        const { onClose, actions } = this.props;

        if (messageId !== null) {
            actions.removeMessage(messageId);
            this.currentMessage = null;
        }

        if (!!onClose) {
            onClose();
        }
    };

    renderInfoMessage = (message, buttonLabel) => (
        <div key={message.id} className={styles.messageItem} ref={(node) => this.setModalRef(node)}>
            <p className={styles.messageItemParagraph}>{message.body}</p>
            <Button
                value={buttonLabel}
                onClick={this.handleCloseClick(message.id)}
            />
        </div>
    );

    renderErrorMessage = (message) => (
        <div key={message.id} className={styles.errorMessageItem} ref={(node) => this.setModalRef(node)}>
            <p className={styles.errorMessageItemParagraph}>{message.body}</p>
            <Button
                icon="times"
                className="errorButton"
                testName="MessageModal__ErrorClose"
                onClick={this.handleCloseClick(message.id)}
            />
        </div>
    );

    render = () => {
        const { messages, intl, testName } = this.props;

        const message = !!messages && messages.length > 0 ? messages[0] : null;
        if (!message) {
            return <></>;
        }

        const modalClassNames = classNames([
            { [styles.messageModal]: message.severity !== 'ERROR' },
            { [styles.messageModalError]: message.severity === 'ERROR' },
        ]);

        const buttonLabel = message.severity !== 'ERROR'
            ? intl.formatMessage({ id: 'messageModal.understoodLabel' })
            : null;

        return (
            <div className={modalClassNames} data-test={testName}>
                { message.severity === 'ERROR' && this.renderErrorMessage(message) }
                { message.severity !== 'ERROR' && this.renderInfoMessage(message, buttonLabel) }
            </div>
        );
    }

}

export const messageShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    severity: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
});

MessageModal.propTypes = {
    actions: PropTypes.objectOf(PropTypes.func).isRequired,
    intl: intlShape.isRequired,
    messages: PropTypes.arrayOf(messageShape),
    testName: PropTypes.string,
    onClose: PropTypes.func,
};

MessageModal.defaultProps = {
    messages: [],
    testName: '',
    onClose: null,
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        removeMessage,
    }, dispatch),
});

export default connect(null, mapDispatchToProps)(injectIntl(MessageModal));
